export default __webpack_public_path__ + "assets/stuntedGhost.c9c872.svg";